import { AnalogTemperatureSensor, HeatingCircuit } from 'z3k-config';
import { getSensorId } from './getters';
import { removeNulls } from 'utils';
import { objects2ids } from 'z3k-parser/lib';
export const renamingNTC = (config) => {
    const ats_ids = objects2ids(AnalogTemperatureSensor.get.all(config));
    const needed_hcs = HeatingCircuit.get.where(config, HeatingCircuit.isConsumer);
    const needed_ats_ids = new Map(removeNulls(needed_hcs.map((hc) => {
        const ats_id = getSensorId(config.object_arrays, ats_ids, hc.id);
        if (!ats_id) {
            return null;
        }
        return [ats_id, hc.name];
    })));
    return AnalogTemperatureSensor.get.modify(config, ({ id }) => needed_ats_ids.has(id), (ats) => ({
        ...ats,
        name: `${ats.name.split(' ')[0]} ${needed_ats_ids.get(ats.id)}`,
    }));
};
